// Internal dependencies
import { TEMPLATES_TYPES } from './templatesTypes';
import { RESULTS_NUMBER } from './resultsNumber';
import { TONES } from './tones';
import { CREATIVITY_LEVELS } from './creativityLevels';
import { PAGE_TYPES } from './pageTypes';
import { EMAIL_TYPES } from './emailTypes';
export const DEFAULT_TEMPLATE = {
    templateType: TEMPLATES_TYPES.GOOGLE_ADS_HEADLINE,
    company: '',
    description: '',
    resultsNumber: RESULTS_NUMBER[2],
    tone: TONES.friendly,
    creativityLevel: CREATIVITY_LEVELS.Creative,
    specialOffer: '',
    pageType: PAGE_TYPES.blog,
    keywords: '',
    emailType: EMAIL_TYPES.welcomeEmail,
    from: '',
    to: '',
};
